import src from "IMAGE";
export default { src, width: 80, height: 78, blurWidth: 0, blurHeight: 0};
